// AUTO-GENERATED GraphQL Builder for WhatsAppTemplate
import * as Builders from '../';
export class WhatsAppTemplateBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  code(){ return this.add('code'); }
  audience(){ return this.add('audience'); }
  label(){ return this.add('label'); }
  description(){ return this.add('description'); }
  varsJson(){ return this.add('varsJson'); }
  body(){ return this.add('body'); }
  enabled(){ return this.add('enabled'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }
}
